import { render, staticRenderFns } from "./LandingWidgetsNew.vue?vue&type=template&id=3dd0f7de&"
import script from "./LandingWidgetsNew.vue?vue&type=script&lang=ts&"
export * from "./LandingWidgetsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports